import { Table } from "@mantine/core";
import React from "react";

import { CustomNumberInput } from "pages/admin/components/CustomNumberInput2";
import { FormTableLayout } from "pages/admin/components/FormatTableLayout";
import { DebtorManagementChildFormProps } from "types/interface.types";

export const FinancialSummaryCard: React.FC<DebtorManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      <FormTableLayout>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Opening"
                value={values.opening}
                onChange={(v) => setFieldValue("opening", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Current"
                value={values.currentMonth}
                onChange={(v) => setFieldValue("currentMonth", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="Balance"
                value={values.balance}
                onChange={(v) => setFieldValue("balance", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="1 Month"
                value={values.month1}
                onChange={(v) => setFieldValue("month1", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="2 Months"
                value={values.month2}
                onChange={(v) => setFieldValue("month2", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly || values.id === 0}
                label="3 Months"
                value={values.month3}
                onChange={(v) => setFieldValue("month3", v)}
              />
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </FormTableLayout>
    </div>
  );
};
export default React.memo(FinancialSummaryCard);
